import React from 'react';
import ReactTooltip from 'react-tooltip';
import '../assets/styles/Glossary.css';

/**
 * Glossary Component
 * 
 * A helper component that wraps text with tooltip definitions
 * Use this component to make terms in the app "hoverable" with explanations
 */
const Glossary = ({ term, definition, children, id }) => {
  // Generate a unique ID if one is not provided
  const tooltipId = id || `term-${term.replace(/\s+/g, '-').toLowerCase()}`;
  
  return (
    <span 
      className="glossary-term"
      data-tip={definition}
      data-for={tooltipId}
    >
      {children || term}
      <ReactTooltip
        id={tooltipId}
        className="glossary-tooltip"
        effect="solid"
        delayShow={300}
        place="top"
        html={true}
      />
    </span>
  );
};

/**
 * GlossaryImage Component
 * 
 * Similar to Glossary but for images
 */
const GlossaryImage = ({ src, alt, definition, id }) => {
  // Generate a unique ID if one is not provided
  const tooltipId = id || `image-${alt.replace(/\s+/g, '-').toLowerCase()}`;
  
  return (
    <span className="glossary-image-container">
      <img 
        src={src}
        alt={alt}
        className="glossary-image"
        data-tip={definition}
        data-for={tooltipId}
      />
      <ReactTooltip
        id={tooltipId}
        className="glossary-tooltip"
        effect="solid"
        delayShow={300}
        place="top"
        html={true}
      />
    </span>
  );
};

export { Glossary, GlossaryImage }; 